<hs-form-field class="w-full">
  <hs-form-label>{{ ibanLabel }}</hs-form-label>
  <input
    #ibanInput
    hsInput
    kfmIbanFormat
    [ibanDetail]="ibanDetail"
    (blur)="ibanDetail.iban = $any($event.target).value"
  />
</hs-form-field>
